var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.title),expression:"title",modifiers:{"bottom":true}}],staticClass:"filename",attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }